// Local translations
export const T = {
  en_GB: {
    questionOf: (current: number, total: number) => `Question ${current} of ${total}`,
    previous: "Previous",
    next: "Next",
    finish: "Finish",
    passedTitle: "Suitable",
    passedBody: "You answered the questions correctly.",
    failedTitle: "Not suitable",
    failedBody: "You did not answer enough questions correctly.",
    attemptsRemaining: (n: number) => `Attempts remaining: ${n}`,
    retryAvailableOn: (date: string) => `You can retry from ${date}.`,
    noAttemptsRemaining: "No attempts remaining.",
    close: "Close",
    cancelTitle: "Cancel quiz?",
    cancelBody: "Your attempt stays open — you can resume where you left off.",
    cancelConfirm: "Leave quiz",
    cancelDismiss: "Continue quiz",
    submitFailed: "Could not submit your answers. Please try again.",
  },
  nb_NO: {
    questionOf: (current: number, total: number) => `Spørsmål ${current} av ${total}`,
    previous: "Forrige",
    next: "Neste",
    finish: "Fullfør",
    passedTitle: "Egnet",
    passedBody: "Du svarte riktig på spørsmålene.",
    failedTitle: "Ikke egnet",
    failedBody: "Du svarte ikke riktig på nok spørsmål.",
    attemptsRemaining: (n: number) => `Forsøk igjen: ${n}`,
    retryAvailableOn: (date: string) => `Du kan prøve igjen fra ${date}.`,
    noAttemptsRemaining: "Ingen forsøk igjen.",
    close: "Lukk",
    cancelTitle: "Avbryte quiz?",
    cancelBody: "Forsøket ditt forblir åpent — du kan fortsette der du slapp.",
    cancelConfirm: "Forlat quiz",
    cancelDismiss: "Fortsett quiz",
    submitFailed: "Kunne ikke sende inn svarene dine. Prøv igjen.",
  },
} as const;
